import { Card, FormattedMessageDiv, FormattedNumberDiv, Button, useWizardContext} from '@odmonorepo/core-components';
import { steps } from '../LoanAppForm';
import { FormattedMessage } from 'react-intl';
import { Fragment } from 'react';
import { Stack } from 'react-bootstrap';
import './ExpressEstimate.css';

type ExpressEstimateProps = {
  applicationData?: any;
};

const ExpressEstimateContent = ({ applicationData }: ExpressEstimateProps) => {
 const estimateValue = applicationData?.properties?.data?.expressEstimateValue ?? 0;
  const wizard = useWizardContext<typeof steps>();
  const onNext = () => {
    wizard.goToStep("FINANCE_STEP");
  };

  return (
    <Stack gap={6}  className="mx-auto" style={{ maxWidth: 600, width: '100%' }}>
      <Stack gap={4} className='text-center'>
        <FormattedMessageDiv className="h3" id="expressEstimate.title" />
      </Stack>
      <Card>
        <Stack gap={5} className="text-center">
          <div className="fs-6 fs-lg-5" data-testid="express-estimate-value">
            <FormattedMessage
              id="expressEstimate.cardHeading"
              values={{
                amount: (
                  <FormattedNumberDiv
                    value={estimateValue}
                    style="currency"
                    currency="USD"
                    maximumFractionDigits={0}
                    className="text-black fs-2 mb-0 fw-semibold"
                  />
                ),
              }}
            />
          </div>
          <FormattedMessageDiv
              className="fs-6 fs-lg-5"
              id="expressEstimate.cardDescription"
            />
          <Button className="express-estimate-btn" onClick={onNext}>
            <FormattedMessage id="expressEstimate.cardCTA" />
          </Button>
        </Stack>
      </Card>
    </Stack>
  );
};

export const ExpressEstimate = ({ applicationData }: ExpressEstimateProps) => {
  return (
    <Fragment>
      <ExpressEstimateContent applicationData={applicationData} />
    </Fragment>
  );
};

export default ExpressEstimate;